export default __webpack_public_path__ + "static/media/250-brazil.8abb3271.svg";